var _excluded = ["__css", "name", "ariaLabel"],
  _excluded2 = ["className", "total", "selectedToggle", "name", "onChange", "getAriaLabel", "isReadOnly"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { forwardRef, tqc, useStyleConfig } from '../../system';
import { cx } from '../../utils';
import { useRadio, useRadioGroup } from '../radio';
import { Box } from '../layout';
function Toggle(props) {
  var {
      __css,
      name,
      ariaLabel
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var {
    getInputProps,
    getCheckboxProps,
    getLabelProps
  } = useRadio(rest);
  return /*#__PURE__*/React.createElement(tqc.label, getLabelProps(), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    name: name,
    "aria-label": ariaLabel
  })), /*#__PURE__*/React.createElement(tqc.div, _extends({}, getCheckboxProps(), {
    __css: __css
  }), /*#__PURE__*/React.createElement(tqc.div, null, props.children)));
}
export var Toggler = forwardRef((props, ref) => {
  var styles = useStyleConfig('Toggler');
  var {
      className,
      total,
      selectedToggle,
      name = 'toggler',
      onChange = () => {},
      getAriaLabel,
      isReadOnly = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var toggleRange = Array.from(Array(total).keys());
  var onChangeHandler = value => {
    onChange(Number(value));
  };
  var {
    getRootProps,
    getRadioProps
  } = useRadioGroup({
    name,
    onChange: onChangeHandler,
    value: selectedToggle === null || selectedToggle === void 0 ? void 0 : selectedToggle.toString()
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    __css: styles.container
  }, getRootProps(), {
    className: cx(className, 'tqc-toggler'),
    ref: ref
  }, rest), toggleRange.map(index => /*#__PURE__*/React.createElement(Toggle, _extends({
    isReadOnly: isReadOnly,
    key: index
  }, getRadioProps({
    value: index.toString()
  }), {
    __css: styles.toggle,
    ariaLabel: getAriaLabel(index)
  }))));
});